import SocketConnection from './SocketConnection';

export default class RecorderServer extends SocketConnection {
    constructor(config) {
        super(config);
    }

    /**
     * 
     * @param {String} sessionId
     */
    async startRecording(sessionId) {
        this._debug('startRecording()', sessionId);

        let result = await this.request('StartRecording', {
            'sessionId': sessionId,
        }, 3000);

        if (result.success) {
            return result.data.recordingId;
        }

        console.warn("Couldn't start recording on server. ", result.message);
        throw new Error("Couldn't start recording on server.");
    }

    async stopRecording(recordingId, lastChunkId) {
        this._debug('stopRecording()', recordingId, lastChunkId);
        
        let result = await this.request('StopRecording', {
            'recordingId': recordingId,
            'lastChunkId': lastChunkId       // keep session open on server until server received last chunk
        }, 3000);

        if (result.success) {
            return true;
        }

        throw new Error("Couldn't stop recording on server.");
    }

    /**
     * 
     * @param {Object} chunk 
     */
    async sendChunk(data) {
        let result = await this.request('UploadChunk', data);
        return result;
    }
}